import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Rightpanel({ myauth }) {
  const [studentProgress, setStudentProgress] = useState([]);
  const [loadingProgress, setLoadingProgress] = useState(false);

  // My Certs အတွက် state များ
  const [studentCerts, setStudentCerts] = useState([]);
  const [loadingCerts, setLoadingCerts] = useState(false);

  useEffect(() => {
    const fetchStudentData = async () => {
      if (!myauth || !myauth.email) return;

      // 1. Fetch Courses / Progress
      setLoadingProgress(true);
      try {
        const response = await fetch(`https://mmao.vercel.app/student/course?email=${encodeURIComponent(myauth.email)}`);
        const resJson = await response.json();

        if (resJson.status === 'success' && resJson.data) {
          setStudentProgress(resJson.data);
        } else {
          setStudentProgress([]);
        }
      } catch (err) {
        console.error('Error fetching student progress:', err);
        setStudentProgress([]);
      } finally {
        setLoadingProgress(false);
      }

      // 2. Fetch Certificates (My Certs)
      setLoadingCerts(true);
      try {
        const certResponse = await fetch(`https://mmao.vercel.app/student/certificates?email=${encodeURIComponent(myauth.email)}`);
        const certJson = await certResponse.json();

        if (certJson.status === 'success' && certJson.data) {
          setStudentCerts(certJson.data);
        } else {
          setStudentCerts([]);
        }
      } catch (err) {
        console.error('Error fetching student certificates:', err);
        setStudentCerts([]);
      } finally {
        setLoadingCerts(false);
      }
    };

    fetchStudentData();
  }, [myauth]);

  return (
    <>
      <div className="blurdiv" onClick={() => {
        document.querySelector('.blurdiv').style.display = 'none';
        document.querySelector('.right-sidebar').style.right = '-323px';
      }}></div>
      <aside className="right-sidebar">
        {myauth && <>
          <div className="user-profile-header">
            <div className="user-info">
              <div className="user-avatar">
                <img src={myauth.photoURL || "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces"} alt={myauth.displayName} />
              </div>
              <div>
                <div className="user-name">{myauth.displayName}</div>
                <div className="user-role">{myauth.email}</div>
              </div>
            </div>
          </div>

          {/* Learning Status Cards (2 Div Grid) */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px' }}>
            <div style={{ background: '#f8fafc', padding: '14px', borderRadius: '12px', border: '1px solid #f1f5f9', textAlign: 'center' }}>
              <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '600', marginBottom: '4px', textTransform: 'uppercase' }}>Total Learning</div>
              <div style={{ fontSize: '18px', fontWeight: '700', color: '#2563eb' }}>
                {loadingProgress ? '...' : studentProgress.length}
              </div>
            </div>
            <div style={{ background: '#f8fafc', padding: '14px', borderRadius: '12px', border: '1px solid #f1f5f9', textAlign: 'center' }}>
              <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '600', marginBottom: '4px', textTransform: 'uppercase' }}>Total Certs</div>
              <div style={{ fontSize: '18px', fontWeight: '700', color: '#059669' }}>
                {loadingCerts ? '...' : studentCerts.length}
              </div>
            </div>
          </div>

          {/* My Courses Section */}
          <div>
            <div className="section-title">
              <span>My Courses</span>
              <span style={{ fontSize: '12px', color: '#2563eb', fontWeight: '600' }}>
                {studentProgress && studentProgress.length > 0 && `${studentProgress.length} Courses`}
              </span>
            </div>

            <div className="progress-list">
              {loadingProgress ? (
                <p style={{ fontSize: '13px', color: '#64748b', textAlign: 'center', padding: '10px 0' }}>Loading courses...</p>
              ) : studentProgress.length > 0 ? (
                studentProgress.map((prog, index) => (
                  <div className="progress-item" key={prog.id || index}>
                    <div className="progress-item-header">
                      <span>{prog.title}</span>
                      <span>#{index + 1}</span>
                    </div>
                    <div className="progress-item-level" style={{ marginBottom: '6px' }}>{prog.level || 'Active'}</div>
                  </div>
                ))
              ) : (
                <p style={{ fontSize: '13px', color: '#64748b', textAlign: 'center', padding: '10px 0' }}>No course records found.</p>
              )}
            </div>
          </div>

          {/* My Certs Section */}
          <div>
            <div className="section-title">
              <span>My Certs</span>
              <span style={{ fontSize: '12px', color: '#059669', fontWeight: '600' }}>
                {studentCerts && studentCerts.length > 0 && `${studentCerts.length} Certs`}
              </span>
            </div>

            <div className="progress-list">
              {loadingCerts ? (
                <p style={{ fontSize: '13px', color: '#64748b', textAlign: 'center', padding: '10px 0' }}>Loading certificates...</p>
              ) : studentCerts.length > 0 ? (
                studentCerts.map((cert, index) => (
                  <Link to={'/certificate/' + cert.certificateId} className="progress-item" key={cert.id || index} style={{ borderLeft: '4px solid #059669' }}>
                    <div className="progress-item-header">
                      <span>{cert.course}</span>
                      <span style={{ fontSize: '11px', background: '#dcfce7', color: '#15803d', padding: '2px 6px', borderRadius: '4px' }}>
                        Grade: {cert.grade}
                      </span>
                    </div>
                    <div className="progress-item-level" style={{ marginBottom: '4px', fontSize: '11px', color: '#64748b' }}>
                      ID: {cert.certificateId}
                    </div>
                    <div style={{ fontSize: '10px', color: '#94a3b8' }}>
                      Issued: {cert.qualifyDate}
                    </div>
                  </Link>
                ))
              ) : (
                <p style={{ fontSize: '13px', color: '#64748b', textAlign: 'center', padding: '10px 0' }}>No certificates found.</p>
              )}
            </div>
          </div>
        </>}
        {!myauth && <div className='rightsignin'>
          <h2>Sign In Required</h2>
          <p>Sign in your account to view your progress and access course.</p>
          <Link to={'/signin'}>Sign In</Link>
        </div>}
      </aside>
    </>
  );
}

export default Rightpanel;